import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  VStack,
  Heading,
  useToast,
  Flex,
  Icon,
  Text,
} from "@chakra-ui/react";
import { FiCheckCircle } from "react-icons/fi";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function AddJobOpening() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState("open");
  const toast = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    toast({
      title: "Job Opening Created",
      description: `Title: ${title} (Status: ${status})`,
      status: "success",
      duration: 3000,
      isClosable: true,
    });
    setTitle("");
    setDescription("");
    setStatus("open");
  };

  const handleSaveAsDraft = (e) => {
    e.preventDefault();
    setStatus("draft");
    toast({
      title: "Job Opening Saved as Draft",
      description: `Title: ${title} (Status: Draft)`,
      status: "info",
      duration: 3000,
      isClosable: true,
    });
    setTitle("");
    setDescription("");
    setStatus("open");
  };

  return (
    <Box
      maxW="800px"
      mx="auto"
      mt={10}
      bg="white"
      borderRadius="lg"
      boxShadow="card"
      p={8}
    >
      <Flex align="center" justify="space-between" mb={6}>
        <Heading fontSize="2xl" color="blue.900">
          Kreiraj Oglas za Posao
        </Heading>
        <Icon as={FiCheckCircle} color="blue.700" boxSize={6} />
      </Flex>

      <form onSubmit={handleSubmit}>
        <VStack spacing={5} align="stretch">
          <FormControl isRequired>
            <FormLabel color="gray.700">Naziv pozicije</FormLabel>
            <Input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="npr. Vanjski stručnjak"
              bg="gray.50"
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel color="gray.700">Opis pozicije</FormLabel>
            <Box bg="gray.50" borderRadius="md" overflow="hidden">
              <ReactQuill value={description} onChange={setDescription} />
            </Box>
          </FormControl>

          <FormControl isRequired>
            <FormLabel color="gray.700">Status</FormLabel>
            <Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              bg="gray.50"
            >
              <option value="open">Otvoren</option>
              <option value="closed">Zatvoren</option>
              <option value="draft">Skica</option>
            </Select>
          </FormControl>

          <Flex spacing={4} justify="flex-start" >
            <Button
              type="submit"
              colorScheme="blue"
              size="md"
              alignSelf="flex-start"
              px={6}
              borderRadius="md"
            >
              Kreiraj Oglas
            </Button>
            <Text
              onClick={handleSaveAsDraft}
              color="blue.600"
              fontSize="md"
              pt={2} pl={2}
              cursor="pointer"
              _hover={{ textDecoration: "underline" }}
              alignSelf="flex-start"
            >
              Ili spemi draft
            </Text>
          </Flex>
        </VStack>
      </form>
    </Box>
  );
}

export default AddJobOpening;
